import {
  apiErrorBodySchema,
  apiErrorEnvelopeSchema,
  apiSuccessEnvelopeSchema,
  type ApiErrorBody,
  type PaginationMeta,
} from "@chotca/config";
import { z } from "zod";
import { ChotcaApiError } from "./errors";

const successFalseSchema = z.object({
  success: z.literal(false),
  error: apiErrorBodySchema,
});

export function parseApiErrorBody(json: unknown): ApiErrorBody | null {
  const fe = apiErrorEnvelopeSchema.safeParse(json);
  if (fe.success) return fe.data.error;
  const sf = successFalseSchema.safeParse(json);
  if (sf.success) return sf.data.error;
  if (
    typeof json === "object" &&
    json !== null &&
    "error" in json &&
    typeof (json as { error: unknown }).error === "object" &&
    (json as { error: unknown }).error !== null
  ) {
    const inner = apiErrorBodySchema.safeParse(
      (json as { error: unknown }).error,
    );
    if (inner.success) return inner.data;
  }
  return null;
}

export function parseSuccessEnvelope<T>(
  json: unknown,
  dataSchema: z.ZodType<T>,
  status: number,
): { data: T; meta?: PaginationMeta } {
  const err = parseApiErrorBody(json);
  if (err) {
    throw ChotcaApiError.fromBody(err, status);
  }

  const envelope = apiSuccessEnvelopeSchema(dataSchema).safeParse(json);
  if (envelope.success) {
    return { data: envelope.data.data, meta: envelope.data.meta };
  }

  throw new ChotcaApiError(
    "INVALID_RESPONSE",
    "Response is not a valid success envelope",
    status,
  );
}
